import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['batch']

  static values = {
    activeId: Number,
  }

  connect() {
    if (!this.hasActiveIdValue) return

    const batch = this.batchTargets.find(
      (target) => target.dataset.batchId === this.activeIdValue.toString()
    )

    if (!batch) return

    requestAnimationFrame(() => {
      batch.classList.add('active')
      batch.scrollIntoView({ behavior: 'smooth', block: 'nearest' })

      setTimeout(() => {
        batch.classList.remove('active')
      }, 1500)
    })
  }
}
